import {routes_phone} from "@/router";
import router from "@/router";

router.addRoute(routes_phone[0]);
